import React from 'react'
import { Route, Redirect } from "react-router-dom"
import {localStore} from "../helpers/localStorage";

function PrivateRoute({component: Component,...rest }) {
   
   let sessionId = localStore.getSession();
   return (
    <Route
      {...rest}
      render={props => {
        return sessionId? <Component {...props} /> : <Redirect to="/" />
      }}
    ></Route>
  )
}

export default PrivateRoute
